import * as React from 'react';

const PriceBreakdownNotice = () => {
    return (
        <div className="w-full">
            <label className="font-semibold">Notice</label>
            <p>
                Your purchase is subject to Nexxt’s <span>Audience Terms</span>{' '}
                of Service and Service-Specific Terms. In the rare case your
                project does not meet these terms and conditions, we&apos;ll
                pause data collection and notify you by email with next steps.
                We process all responses with machine learning to check for
                quality and compliance, which helps us maintain a reliable panel
                of respondents. Under some circumstances, the project may not be
                delivered by this estimated delivery time.{' '}
                <span>Terms and Services</span>
            </p>
        </div>
    );
};

export default PriceBreakdownNotice;
